var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"edit-button"},[_c('i',{staticClass:"fas fa-edit edit-icon"})])
}]

export { render, staticRenderFns }